var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTickOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96601 0.664062C3.93935 0.664062 0.666016 3.9374 0.666016 7.96406C0.666016 11.9907 3.93935 15.2641 7.96601 15.2641C11.9927 15.2641 15.266 11.9907 15.266 7.96406C15.266 3.9374 11.9927 0.664062 7.96601 0.664062ZM13.9993 7.96406C13.9993 11.2907 11.2927 13.9974 7.96601 13.9974C4.63935 13.9974 1.93268 11.2907 1.93268 7.96406C1.93268 4.6374 4.63935 1.93073 7.96601 1.93073C11.2927 1.93073 13.9993 4.6374 13.9993 7.96406Z",
    fill: "#17B31B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1664 5.62795C11.3853 5.84294 11.3885 6.19468 11.1735 6.41359L7.35404 10.3025C7.24958 10.4088 7.10676 10.4688 6.95768 10.4688C6.8086 10.4688 6.66578 10.4088 6.56132 10.3025L4.82521 8.5348C4.61022 8.3159 4.61339 7.96415 4.83229 7.74916C5.05119 7.53416 5.40294 7.53733 5.61793 7.75624L6.95768 9.12035L10.3808 5.63502C10.5958 5.41612 10.9475 5.41295 11.1664 5.62795Z",
    fill: "#17B31B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickOutline);
export default __webpack_public_path__ + "static/media/green-tick-outline.5e4b68ea2354cf4de64ac8cc2ee858a2.svg";
export { ForwardRef as ReactComponent };